export default "__VITE_ASSET__BNB7tz4B__"